import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useStartMeeting, useUser } from '../../hooks';
import { isHostedByTeamHub } from '../../services/hostAuthService';
import { Header } from '../Header';
import { JoinMeetingModal } from '../JoinMeetingModal';
import { LandingPage } from '../LandingPage';

const UnauthenticatedLanding: React.FC = () => {
  const { login, isLoading: loginInProgress, error: authError } = useUser();

  const [errorDismissed, setErrorDismissed] = useState(false);
  const [isJoinMeetingOpen, setIsJoinMeetingOpen] = useState(false);

  const { startMeetingUnauth: handleStartMeetingUnauth } = useStartMeeting();

  useEffect(() => {
    if (authError) {
      setErrorDismissed(false);
    }
  }, [authError]);

  const handleJoinMeeting = useCallback(() => {
    setIsJoinMeetingOpen(true);
  }, []);

  return (
    <>
      <JoinMeetingModal isOpen={isJoinMeetingOpen} onClose={() => setIsJoinMeetingOpen(false)} />
      <div id="LandingPage">
        {!isHostedByTeamHub() && <Header onLogin={() => login()} isAuthenticated={false} />}
        <LandingPage
          loginInProgress={loginInProgress}
          onLogin={() => login()}
          onStartMeeting={handleStartMeetingUnauth}
          onJoinMeeting={handleJoinMeeting}
          authError={authError}
          errorDismissed={errorDismissed}
          handleErrorDismiss={() => setErrorDismissed(true)}
        />
      </div>
    </>
  );
};

export default UnauthenticatedLanding;
